export default __webpack_public_path__ + "static/media/work-record.d75e9d18.svg";